<template>
    <div class="splash" v-if="useBanner" >
        <img src="../../assets/images/healthtalk.jpg" class="splash-img">
    </div>
</template>
<script>
    import { mapActions } from "vuex"
    export default {
        components: {
        },
        data() {
            return {
            }
        },
        computed: {
            isiOS () {
                return /iPhone|iPad|iPod/i.test(navigator.userAgent);
            },
            isDBInsurance() {
                if ( process.env.VUE_APP_TARGET_COMPANY === 'db-insurance') {
                    return true
                }
                return false
            },
            targetCompany () {
                return process.env.VUE_APP_TARGET_COMPANY
            },
            useBanner () {
                const { targetCompany } = this
                const useBannerList = ['shinhan']
                return useBannerList.some(company => targetCompany === company)
            }
        },
        async mounted() {
            this.setHome('/')
            if(this.isDBInsurance) {
                return this.$router.push('/intro-db')
            } else if (this.targetCompany === 'gangnam') {
                return this.$router.push('/fromGangnam')
            } else {
                await new Promise(resolve => setTimeout(resolve, 2000))
                return this.$router.push('/intro')
            }
        },
        methods: {
            ...mapActions('user', [
                'setHome',
            ])
        }
    }
</script>
<style scoped>
    .splash {
        display: relative;
        width: 100vw;
        height: 100vh;
        text-align: center;
        /*background-color: #f16522;*/
        background-color: #404040;
    }

    @media screen and (min-width: 501px) {
        .splash {
            display: relative;
            width: 500px;
            height: 100vh;
            text-align: center;
            /*background-color: #f16522;*/
            background-color: #404040;
        }
    }

    .fadeOut {
        animation: fadeOut ease 1s;
        -webkit-animation: fadeOut ease 1s;
        -moz-animation: fadeOut ease 1s;
        -o-animation: fadeOut ease 1s;
        -ms-animation: fadeOut ease 1s;
    }

    @keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-moz-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-o-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-ms-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    .splash-img {
        width: 90%;
    }

    .health-talk {
        margin-top: 20vh;
        width: 50vw;
    }
    .health-talk.ios {
        margin-top: 25vh;
    }

</style>
